import { Component, Input } from '@angular/core';
import { TitledCount } from 'app/models/report-details.models';
import { NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-citation-details',
  templateUrl: './citation-details.component.html',
  styleUrls: ['./citation-details.component.scss'],
  imports: [NgFor, NgIf],
})
export class CitationDetailsComponent {
  @Input() details: { title: string; data: TitledCount[] }[] = [];
}
